import { getAccessTokenFromLocal } from "Services/helpers"
import { API_URL } from "Store/Shared/Middleware/API/Constants";

export class RelationService {
    fetchRelations = async (relationIds: any[]) => {
        const accessToken = getAccessTokenFromLocal();
        
        const prepareRelationValues = relationIds.join(',');
        const url = `${API_URL}/api/field-management/relations/${prepareRelationValues}`;
        let response: any = await fetch(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
    
        if (response.status !== 200 || !response.ok) {
            return [];
        }

        response = await response.json();

        return response?.data;
    }
}